import React from "react";
import { Link } from "gatsby";
import scrollTo from 'gatsby-plugin-smoothscroll';

const NavLinkDesktop = ({  linkData }) => {
  const { title, link, externalLink} = linkData;
  function navigateToPartners() {
    if(window.location.href.indexOf("company/why-grootan") == -1) {
      window.location.href = "/company/why-grootan#our-partners";
    }
    sessionStorage.clear();
    scrollTo("#our-partners");
  }
  return externalLink ?  (
    <li className="nav-sub-item">
    <a
      className="tagmanager-nav-top  nav-sub-label"
      rel="noreferrer noopener"
      href={`${link}/`}
      target="_blank"
      title={`${title} page link`}
      noPrefetch
    >
      {title}
    </a>
  </li>
  ) : title === "Our Partners" ? (
    <li className="nav-sub-item">
      <p
        className="tagmanager-nav-top  nav-sub-label"
        rel="noreferrer noopener"
        title={`${title} page link`}
        onClick={() => navigateToPartners()}
        noPrefetch
      >
        {title}
      </p>
    </li>
  ) : (
    <li className="nav-sub-item">
      <Link
        to={`${link}/`}
        className={`tagmanager-nav-top  nav-sub-label`}
        title={`${title} page link`}
        noPrefetch
      >
        <span className="label">{title}</span>
      </Link>
    </li>
  );
};

export default NavLinkDesktop;
